// src/components/Footer.js
import React from 'react';
import './Footer.css';
import uniconLogo from '../assets/Unicon-Logo-Blue.webp';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footerInner">
        {/* Top row: logo/tagline/social + columns of links */}
        <div className="footerTop">
          <div className="footerLogoArea">
            <div className="footerLogo">
              <div data-svg-wrapper>
        <svg width="126" height="28" viewBox="0 0 126 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_3497_126)">
            <path d="M4 23.9687C4.00001 20.2991 4 10.5763 4 4.02417C8.1806 4.02417 8.49213 4.02417 14.0334 4.02417C19.5748 4.02417 24.0669 8.49139 24.0669 14.002C24.0669 16.666 24.0669 19.4454 24.0669 23.9687" stroke="#053F55" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28.4305 14C28.4305 19.5107 32.9227 23.9779 38.464 23.9779C42.3946 23.9779 45.7973 21.7302 47.4434 18.4568M28.4305 14C28.4305 8.48944 32.9227 4.02222 38.464 4.02222C44.0053 4.02222 48.4974 8.48944 48.4974 14H28.4305Z" stroke="#053F55" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M52.8605 4C52.8605 4 52.8605 14 62.9162 14C72.972 14 72.972 4 72.972 4" stroke="#053F55" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M52.8606 23.9999C52.8606 23.9999 52.8606 13.9999 62.9163 13.9999C72.9721 13.9999 72.9721 23.9999 72.9721 23.9999" stroke="#053F55" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M77.3357 14C77.3357 19.5107 81.8278 23.9779 87.3691 23.9779C91.2997 23.9779 94.7025 21.7302 96.3485 18.4568M77.3357 14C77.3357 8.48944 81.8278 4.02222 87.3691 4.02222C92.9104 4.02222 97.4026 8.48944 97.4026 14H77.3357Z" stroke="#61AECA" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M101.766 4.02212C107.151 4.02212 106.258 4.02212 111.8 4.02212C117.341 4.02212 121.833 8.48935 121.833 13.9999C121.833 19.5106 117.341 23.9778 111.8 23.9778C108.527 23.9778 107.452 23.9778 101.766 23.9778L101.766 18.5676" stroke="#61AECA" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_3497_126">
              <rect width="121.833" height="24" fill="white" transform="translate(2 2)" />
            </clipPath>
          </defs>
          </svg>
              </div>
            </div>
            <p className="footerTagline">
              Intelligence from the nexus of business and education
            </p>
            <div className="socialIcons">
              <a href="https://www.linkedin.com/company/nexed-insight" aria-label="LinkedIn" className="socialLink">
                <i className="fa-brands fa-linkedin" />
              </a>
            </div>
          </div>

          <div className="footerLinks">
            <div className="footerColumn">
              <h4>Services</h4>
              <ul>
                <li><a href="/services#primary-research-advisory">Primary Research</a></li>
                <li><a href="/services#positioning-brand-market-strategy">Brand Positioning & Strategy</a></li>
                <li><a href="/services#content-marketing-thought-leadership">Content & Thought Leadership</a></li>
              </ul>
            </div>

            <div className="footerColumn">
              <h4>About</h4>
              <ul>
                <li><a href="/about">About</a></li>
                <li><a href="/reports">Reports</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>

            <div className="footerColumn">
              <h4>Contact</h4>
              <ul>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/antitrust">Anti-Trust</a></li>
                <li><a href="/privacy">Privacy</a></li>
                <li><a href="/cookies">Cookies</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footerBottom">
          <div className="footerBottomLeft">
            © 2025 Nexed. All rights reserved.
          </div>
          <div className="footerBottomRight">
            In Partnership with
            <img src={uniconLogo} alt="UNICON" className="uniconLogo" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;